import { render, staticRenderFns } from "./Hemei.vue?vue&type=template&id=2ad845b6&scoped=true"
import script from "./Hemei.vue?vue&type=script&lang=js"
export * from "./Hemei.vue?vue&type=script&lang=js"
import style0 from "./Hemei.vue?vue&type=style&index=0&id=2ad845b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad845b6",
  null
  
)

export default component.exports